export const STAGES_ENDPOINTS = {
  BASE: "/v1/stages",
  DETAIL: (id: string) => `/v1/stages/${id}`,
} as const;
